import React, {useState} from 'react';
import {consignorService} from '../../../services';
import {Modal, Input, notification, Button} from 'antd';
import i18n from '../../../i18n';

export default function ModalRefuseGosLog({isShow, setIsShow, setNeedUpdate, orderId, setStopListUpdate}) {

  const {TextArea} = Input;

  const [refuseReason, setRefuseReason] = useState('');

  const handleRefuse = () => {
    consignorService
      .refuseGosLog(orderId, refuseReason)
      .then(resp => {
        if (resp.code !== 400) {
          notification.success(
            { message: i18n.t('components.notification.titles.refuseOrderToConsignor'),
              description: resp.message });

          setIsShow(false);
          setNeedUpdate(true);
          setStopListUpdate(false);
        } else {
          notification.error(
            { message: i18n.t('components.notification.titles.refuseOrderToConsignor'),
              description: resp.message });
        }
      })
      .catch(errMsg => notification.error(
          { message: i18n.t('components.notification.titles.refuseOrderToConsignor'),
            description: errMsg }));
  };

  return (
    <Modal
      title={i18n.t('modals.modalRefuseOrderToConsignor.title')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={[
          <Button disabled={!refuseReason} onClick={handleRefuse} className="small-button typical-btn-red">{i18n.t('main.buttons.decline')}</Button>
      ]}
    >
      <TextArea rows={20} onChange={e => setRefuseReason(e.target.value)} value={refuseReason} placeholder={i18n.t('modals.modalRefuseOrderToConsignor.fields.refuseReason.title')} />
    </Modal>
  );

}
